import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemKeepsReturning() {
  const commonSituations = ['You get told what it costs, but not always why', "You're not sure what was actually inspected versus just serviced", "You find out about a problem when it's already expensive", "You've never seen photos or video of your own car mid-inspection", "You trust your shop, but you'd be hard-pressed to describe their process"];
  return <section className="py-20 px-4 bg-brand-light space-y-[6px] pt-[30px] pb-[30px]" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        {/* Part 1: When the problem keeps coming back */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-10 pt-[30px] pb-[30px] space-y-[20px]" data-id="element-129">
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-8 text-center" data-id="element-130">
            Most drivers have no idea what's actually going on with their car.
          </h2>

          <p className="text-xl text-gray-700 mb-8 text-center font-bold pl-[49px] pr-[49px]" data-id="element-131">
            And that's not their fault. It's what their shop shows them.
          </p>

          <div className="text-lg md:text-xl text-gray-700 mb-10 text-center space-y-4" data-id="element-132">
            <p data-id="element-133">
              If your current shop doesn't send you photos and video of your
              vehicle, a prioritized list of what needs attention, and a clear
              explanation of what's urgent versus what can wait — you're making
              decisions without the full picture.
            </p>
            <p className="font-bold text-brand-dark pl-[75px] pr-[75px]" data-id="element-134">
              That's not good car care. That's just good enough.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 pt-[32px] pb-[32px] mt-[37px] mb-[37px]" data-id="element-135">
            <p className="font-bold text-brand-dark text-lg mb-6" data-id="element-136">
              Sound familiar?
            </p>
            <ul className="space-y-4" data-id="element-137">
              {commonSituations.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-138">
                  <AlertCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-139" />
                  <span className="text-lg text-gray-700" data-id="element-140">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center space-y-3" data-id="element-141">
            <p className="text-xl text-brand-dark font-bold" data-id="element-142">
              If you don't know what your shop is checking — or skipping —
              neither do you.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}